import { formatBoolean } from "@/shared/text";
/**
 * Render a metadata cell value for display in a table. Primitives stringify
 * normally; objects / arrays go through `JSON.stringify` so a value like
 * `{ bar: 5 }` shows up as `{"bar":5}` instead of `[object Object]`.
 *
 * Mirrors `toDisplayable` in
 * `shared/components/SearchResultViews/tableLogic.ts` so the new
 * DataTable-based lists render metadata identically to the older Search
 * results table.
 */
export function formatMetadataValue(value: unknown): string {
  if (value === undefined || value === null) {
    return "";
  }
  switch (typeof value) {
    case "string":
      return value;
    case "boolean":
      return formatBoolean(value);
    case "number":
    case "bigint":
      return value.toString();
    default:
      return JSON.stringify(value) ?? "";
  }
}
